type navigateType = (value: string) => void

export const clearURLQueryParam = (key: string, navigate: navigateType) => {
  const url = new URL(document.URL)
  const params = url.searchParams
  navigate(window.location.pathname)
  params.delete(key)
}

export const replaceURLParams = (currentStep: number, key: string, navigate: navigateType) => {
  const url = new URL(document.URL)
  const params = url.searchParams
  navigate(`?${key}=${currentStep - 1}`)
  params.set(key, (currentStep - 1).toString())
}

export const getURLQueryParam = (key: string) => {
  const url = new URL(document.URL)
  const urlsp = url.searchParams
  const param = urlsp.get(key)
  return param ? parseInt(param) : 0
}
